module.exports = __webpack_public_path__ + "static/media/112.f1d4449e.png";